'use strict';

function FlightSummaryGridDirective() {
  return {
    restrict: 'E',
    controller: 'FlightSummaryGridController',
    template: require('../templates/flight-summary-grid.html'),
    scope: {
      screenState: '=',
      reoptPreviewData: '='
    },
    link: function link(scope) {
      scope.$on('search-criteria:searchChangeEvent', scope.onSearchCriteriaChange);
      scope.$on('collapsable-panel-trigger', scope.onPanel);
      scope.$on('re-opt:undo-finished', scope.refreshAfterReOpt);
      scope.$on('re-opt:save-finished', scope.refreshAfterReOpt);
      scope.$on('sendGrid', scope.sendGridHandler);
      scope.$on('profile-chart-panel:swap', scope.profileChartPanelSwapHandler);
      scope.$on('grid:gridCustomizationChanged', scope.gridCustomizationChangedHandler);
      scope.$on('grid:afterUpdateBoundData', scope.afterUpdateBoundDataHandler);
      scope.$on('grid:onSelectedPrevKey', scope.onSelectedKey);
      scope.$on('grid:onSelectedNextKey', scope.onSelectedKey);
      scope.$watch('reoptPreviewData.mdReopt.read', scope.reoptPreviewDataHandler);
      scope.$watch('screenState.flightManagementMode.visible', scope.fmVisibilityChangeHandler);
    }
  };
}
FlightSummaryGridDirective.$inject = [];
module.exports = FlightSummaryGridDirective;